import React, { useEffect, useState } from "react";
import Navigation from "../navigation/mainNavBar";

import "../footer/Policy.scss";

import Footer from "../footer/Footer";

function Faq() {
  useEffect(() => {
    const sectionOffset =
      document.querySelector("section:first-of-type").offsetTop * 0.8;
    window.scrollTo({
      top: sectionOffset,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="Faq">
      <Navigation />
      <div className="content">
        <div className="title">WildLandsRP</div>
        <div className="sub-title">
          Przyjaciele, wrogowie i fortuna czekają na Ciebie!
        </div>
        <div className="main-butons-line"></div>
      </div>
      <div className="section-title">NAJCZĘŚCIEJ ZADAWANE PYTANIA</div>
      <section className="grid2">
        <div className="grid-item"></div>
        <div className="grid-item">
          <p>
            <strong>Q: </strong> Masz ochotę komuś zapłacić za jego usługi?
          </p>
          <p>
            <strong>A: </strong> Wpisując /moneyclip (kwota) stworzysz klip
            gotówki który możesz przekazać pod klawiszem “B”.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Chciałbyś ubrać się jak prawdziwy dżentelmen?
          </p>
          <p>
            <strong>A: </strong> W przebieralni możesz się obrócić “E”, “Q”
            przybliżać scrollem a trzymając “PPM” możesz spojrzeć lepiej na
            buty, bądź kapelusz.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Chcesz udać się na polowanie, ale nie wiesz, od
            czego zacząć?
          </p>
          <p>
            <strong>A: </strong> Żeby oskórować zwierzę potrzebny ci będzie nóż,
            który zakupisz u rusznikarza.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Zastanawia cię ile posiadasz przy sobie
            pieniędzy albo jak dużo jeszcze udźwigniesz?
          </p>
          <p>
            <strong>A: </strong> Po otworzeniu ekwipunku na dole znajdziesz
            swoje odpowiedzi.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Chciałbyś odpocząć podczas łowienia ryb?
            Zapewne przyda Ci się do tego przynęta.
          </p>
          <p>
            <strong>A: </strong> Udaj się na bagienne tereny. Znajdziesz tam
            sklep z przynętami.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Udało ci się zdobyć trochę mięsa i chciałbyś je
            ugotować?
          </p>
          <p>
            <strong>A: </strong> Stwórz ognisko i postaw je gdzie chcesz, tyle
            ci wystarczy, by upiec podstawowe rzeczy.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Masz problem ze ścinaniem drzew?
          </p>
          <p>
            <strong>A: </strong> Chwyć siekierę, stań spokojnie i dobrze
            wyceluj.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Kupiłeś konia tylko za kilka dolarów i
            zazdrościsz innym?
          </p>
          <p>
            <strong>A: </strong> Zajmij się nim odpowiednio. Nakarm dobrze,
            szczotkuj, a nawiążesz lepszą więź.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Masz za małe kieszenie i już bardziej się ich
            wypchać nie da?
          </p>
          <p>
            <strong>A: </strong> Pamiętaj, że możesz wykorzystać dodatkowe
            miejsce, które gwarantuje posiadanie własnego konia.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Chcesz zostać szeryfem/lekarzem?
          </p>
          <p>
            <strong>A: </strong> Zgłoś się do przedstawiciela danej profesji i
            zapytaj jak możesz to zrobić.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Dużo się nakopałeś i nie wiesz co dalej?
          </p>
          <p>
            <strong>A: </strong> Przetop swoje rudy i popytaj mieszkańców, może
            coś kupią.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Zmęczyłeś się w kopalni bądź w lesie i nie
            wiesz jak odpocząć?
          </p>
          <p>
            <strong>A: </strong> Zjedz coś dobrego bądź napij się np. wody.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Masz dość oglądania zwłok i grzebania w ich
            kieszeniach?
          </p>
          <p>
            <strong>A: </strong> Znajdź odpowiedniego człowieka, który pokieruje
            Cię w dalszych działaniach.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Romantyk z Ciebie, a może chcesz załatwić kilka
            spraw na odległość?
          </p>
          <p>
            <strong>A: </strong> Na poczcie możesz wysłać lub odebrać listy.
            Wystarczy Ci nr skrytki, który ktoś ci poda.
          </p>
          <br />
          <p>
            <strong>Q: </strong> Zdarzyło Ci się kupić przypadkiem dwa noże
            zamiast jednego?
          </p>
          <p>
            <strong>A: </strong> Kartkować strony można trzymając też za górny
            róg katalogu.
          </p>
          <br />
        </div>
        <div className="grid-item"></div>
      </section>
      <Footer />
    </div>
  );
}

export default Faq;
